<template>
  <modal name="linksRodapeEdit" height="auto" width="900" :scrollable="true" :clickToClose="true">
    <div class="modalbox">
      <div class="modalbox-content">
        <div class="row">
          <ul class="tabs">
            <li class="tab-active">
              <a>Editando Link</a>
            </li>
          </ul>
        </div>
        <div class="form">
          <div class="row">
            <div class="col-1-2">
              <div class="form-group">
                <label for>Descrição</label>
                <input type="text" v-model="item.descricao" class="form-control">
                <div class="message">{{ validation.firstError('item.descricao') }}</div>
              </div>
            </div>
            <div class="col-1-4">
              <div class="form-group">
                <label for>Aba</label>
                <select v-model="item.aba" class="form-control">
                  <option value>-</option>
                  <option :value="true">Sim</option>
                  <option :value="false">Não</option>
                </select>
                <div class="message">{{ validation.firstError('item.aba') }}</div>
              </div>
            </div>
            <div class="col-1-4">
              <div class="form-group">
                <label for>Ordem</label>
                <input type="number" v-model="item.ordem" class="form-control">
                <div class="message">{{ validation.firstError('item.ordem') }}</div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-1-2">
              <div class="form-group">
                <label for>Tipo de Link</label>
                <select v-model="item.tipo" class="form-control" @change="changeTipo">
                  <option value>-</option>
                  <option v-for="option in this.tipos.labels" v-bind:value="option">{{ option }}</option>
                </select>
              </div>
            </div>
            <div class="col-1-2">
              <div class="form-group">
                <label for>{{ item.tipo || '-' }}</label>
                <select v-model="item.link" class="form-control" :disabled="this.isLinkExterno()">
                  <option value>-</option>
                  <option v-for="option in tipoValues" v-bind:value="option.url">{{ option.titulo }}</option>
                </select>
              </div>
            </div>
            <div class="col-1-2">
              <div class="form-group">
                <label for>Seção do Rodapé</label>
                <select v-model="item.secaoId" class="form-control">
                  <option
                    v-for="secao in secoesRodape"
                    v-bind:value="secao._id"
                  >{{ secao.descricao }}</option>
                </select>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-1">
              <div class="form-group">
                <label for>Link</label>
                <input
                  type="text"
                  v-model="item.link"
                  class="form-control"
                  :disabled="!this.isLinkExterno()"
                >
                <!-- <div class="message">{{ validation.firstError('item.link') }}</div> -->
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-actions">
              <button
                :class="{ 'button button-success button-lg': true, 'button-disabled': validation.hasError() }"
                v-on:click="handleSubmit"
              >Alterar</button>
              <button class="button button-lg" v-on:click="close">Fechar</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>
<script>
import SimpleVueValidation from "simple-vue-validator";
const Validator = SimpleVueValidation.Validator;

export default {
  name: "linksRodapeEdit",
  props: {
    tipos: {
      default: function() {
        return { labels: [], values: [] };
      }
    },
    secoesRodape: {
      default: function() {
        return [{ descricao: "", _id: "" }];
      }
    },
    item: true,
    update: true,
    close: true
  },
  watch: {
    item: function(newVal, oldVal) {
      this.tipoValues = this.tipos.values[newVal.tipo];
    }
  },
  data() {
    return {
      tipoValues: []
    };
  },
  validators: {
    // "item.link": function(value) {
    //   return Validator.value(value).required();
    // },
    "item.ordem": function(value) {
      return Validator.value(value)
        .required()
        .digit();
    },
    "item.descricao": function(value) {
      return Validator.value(value).required();
    },
    "item.aba": function(value) {
      return Validator.value(value).required();
    }
  },
  methods: {
    handleSubmit() {
      this.$validate().then(success => {
        if (success) {
          this.update();
        }
      });
    },
    isLinkExterno() {
      return this.item && this.item.tipo === "Link Externo";
    },
    changeTipo() {
      if (this.isLinkExterno()) {
        this.tipoValues = [];
      } else {
        this.tipoValues = this.tipos.values[this.item.tipo];
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/views/Links/Rodape/Edit.vue